import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setBillingAddress } from "../../store/orderEntitySlice";
import { numValidate } from "../../../shared/helpers/numberValidate";
import pincodeData from "../../../../assets/indiaPincode.json"
import { placeOfSupplyList } from "../../../shared/config/placeOfSupply";

const Pincode = () => {
  const dispatch = useDispatch();
  const { pincode } = useSelector(
    (state) => state?.orderEntity?.order_billing_addresses[0]
  );
  console.log("pincode", pincode);
  return (
    <>
      <Form.Label>Pincode</Form.Label>
      <Form.Control
        maxLength={6}
        name="pincode"
        type="text"
        value={pincode}
        onKeyPress={(event) => numValidate(event)}
        onChange={(e) => {
          const { value } = e.target;
          let data = {
            field: "pincode",
            value: value,
          };
          dispatch(setBillingAddress(data));
          if (value?.length === 6) {
            const pincodeEntry = pincodeData.find(p => p.pincode == value);
            if (pincodeEntry) {
              const stateOption = placeOfSupplyList.find(option => option.label.toUpperCase() == pincodeEntry.statename);
              let cityData = {
                field: "city",
                value: pincodeEntry.Districtname,
              };
              dispatch(setBillingAddress(cityData));
              let stateData = {
                field: "state",
                value: stateOption ? stateOption.value : "",
              };
              dispatch(setBillingAddress(stateData));

            }
          }

        }}
      />
    </>
  );
};

export default Pincode;
